package com.arenaproplay.admin.ui.components.admin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.arenaproplay.admin.ui.utils.sBorderRadius
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Input

/**
 * Keystrokes update the field immediately, but [onValueChange] fires only
 * after [debounceMs] of quiet — one request per pause instead of one per key.
 */
@Composable
fun SearchInput(
    value: String,
    onValueChange: (String) -> Unit,
    placeholderText: String = "Search…",
    modifier: Modifier = Modifier,
    debounceMs: Int = 300
) {
    var text by remember { mutableStateOf(value) }
    LaunchedEffect(value) { if (value != text) text = value }
    LaunchedEffect(text) {
        if (text != value) {
            delay(debounceMs.toLong())
            onValueChange(text)
        }
    }
    Row(
        modifier
            .classNames("na-search-input")
            .sBorderRadius(999)
            .padding(leftRight = 18.px, topBottom = 11.px)
            .styleModifier {
                property("background", "#0B1220")
                property("border", "1px solid rgba(255,255,255,0.06)")
                property("min-width", "300px")
                property("transition", "border-color 160ms ease, box-shadow 160ms ease")
                property("box-shadow", "0 1px 2px rgba(0,0,0,0.03)")
            },
        verticalAlignment = Alignment.CenterVertically
    ) {
        SpanText("⌕", Modifier.fontSize(15.px).color(Color("#A7ADB9")))
        Box(Modifier.width(12.px))
        Input(
            type = InputType.Text,
            attrs = Modifier
                .fillMaxWidth()
                .toAttrs {
                    value(text)
                    placeholder(placeholderText)
                    onInput { text = it.value }
                    style {
                        property("background", "transparent")
                        property("border", "none")
                        property("outline", "none")
                        property("color", "#F0F4FC")
                        property("font-family", "Inter, sans-serif")
                        property("font-size", "13px")
                        property("font-weight", "500")
                        property("width", "100%")
                        property("letter-spacing", "0.01em")
                    }
                }
        )
    }
}
